// extracted by mini-css-extract-plugin
export default {"container":"Handbuchdownload_container__+dOZW","text":"Handbuchdownload_text__cAafE","contactBtn":"Handbuchdownload_contactBtn__7ix4x","space":"Handbuchdownload_space__PMZ2A"};